module.exports = __webpack_public_path__ + "static/media/covid19_1.6ce9074d.png";